import { render, staticRenderFns } from "./TabLicense.vue?vue&type=template&id=16c1fa31&scoped=true&"
import script from "./TabLicense.vue?vue&type=script&lang=js&"
export * from "./TabLicense.vue?vue&type=script&lang=js&"
import style0 from "./TabLicense.vue?vue&type=style&index=0&id=16c1fa31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c1fa31",
  null
  
)

export default component.exports